import {LOAD_PROPERTYVEHICLE_DATA, DELETE_A_PROPERTYVEHICLE, SAVE_A_PROPERTYVEHICLE, UPDATE_A_PROPERTYVEHICLE,CLEAR_A_PROPERTYVEHICLE_ERROR_MESSAGE} from './actions';


const initialState = {
  propertyvehiclesArray:[],
    deletePropertyvehicleResp:{},
    errorCMsg:{},
    savePropertyvehicleResp:{},
    updatePropertyvehicleResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_PROPERTYVEHICLE_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_PROPERTYVEHICLE_DATA:
          return Object.assign({}, state, {
              propertyvehiclesArray: action.propertyvehiclesData
          });
          case DELETE_A_PROPERTYVEHICLE:
          return Object.assign({}, state, {
              deletePropertyvehicleResp: action.deletePropertyvehicleResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_PROPERTYVEHICLE:
          return Object.assign({}, state, {
              savePropertyvehicleResp: action.savePropertyvehicleResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_PROPERTYVEHICLE:
          return Object.assign({}, state, {
              updatePropertyvehicleResp: action.savePropertyvehicleResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
